;(function($, window, document){
    window.BillingForm = Me.view.extend({
        options: {
            stripe: null,
            elements: null,
            cardNumber: null,
            cardExpiry: null,
            cardCvc: null,
            cardName: null,
            waypoint: null,
            waypointEndOfPage: null,
            antispam: false,
            noPaymentRequired: false
        },

        initialize: function() {
            _.bindAll(this, 'initStripe', 'addEvents', 'submitForm', 'createWaypoints');

            if(!this.$('form').hasClass('no-payment-required')){
                this.initStripe();
            }else{
                this.options.noPaymentRequired = true;
            }

            this.addEvents();
        },
        initStripe: function(){
            // Create a Stripe client
            this.options.stripe = Stripe(stripeKey);

            // Create an instance of Elements
            this.options.elements = this.options.stripe.elements();

            // Custom styling can be passed to options when creating an Element.
            // (Note that this demo uses a wider set of styles than the guide below.)
            var elementStyles = {
                base: {
                    color: '#57544E',
                    lineHeight: '23px',
                    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                    fontSmoothing: 'antialiased',
                    fontSize: '18px',
                    '::placeholder': {
                        color: '#A5A29E'
                    }
                },
                invalid: {
                    color: '#A92A2A',
                    iconColor: '#fa755a'
                }
            };

            // Add an instance of the card Element into the `card-element` <div>
            this.options.cardNumber = this.options.elements.create('cardNumber', {
                style: elementStyles
            });
            this.options.cardNumber.mount('#card-number');

            this.options.cardExpiry = this.options.elements.create('cardExpiry', {
                style: elementStyles
            });
            this.options.cardExpiry.mount('#card-expiry');

            this.options.cardCvc = this.options.elements.create('cardCvc', {
                style: elementStyles
            });
            this.options.cardCvc.mount('#card-cvc');
        },
        addEvents: function(e){
            this.$('#payment-form .cta').on('click', this.submitForm);
            this.$('.radio-ctn.paypal').on('click', this.payWithPaypal);
            Me.dispatch.subscribe('breakpointChanged', this.createWaypoints);
        },
        createWaypoints: function(e, params){
            var view = this;

            if (this.options.waypoint) {
                this.options.waypoint.destroy();
                this.options.waypointEndOfPage.destroy();
            }

            $(window).scrollTop(0);
            view.$el.removeClass('fixed').css('top', '');

            if(params.breakpoint != '767-' && params.breakpoint != '768-1023' && $('.products').outerHeight(true) + $('#pricing-total').outerHeight(true) > $('.form-wrapper').outerHeight(true)) {
                this.options.waypoint = new Waypoint({
                    element: this.$el,
                    offset: '20%',
                    handler: function (direction) {
                        if (direction == 'down') {
                            view.$el.addClass('fixed')
                        } else {
                            view.$el.removeClass('fixed')
                        }
                    }
                });

                this.options.waypointEndOfPage = new Waypoint({
                    element: $('#pricing-total'),
                    offset: function () {
                        return $(window).height() - $('#pricing-total').outerHeight() - 100;
                    },
                    handler: function (direction) {
                        if (direction == 'down') {
                            view.$el.removeClass('fixed').css('top', $('.products').outerHeight(true) + $('#pricing-total').outerHeight(true) - $('.form-wrapper').outerHeight(true))
                        } else {
                            view.$el.addClass('fixed').css('top', '');
                        }
                    }
                });
            }
        },
        submitForm: function(e){

            if(this.options.noPaymentRequired){
                this.$('#payment-form').submit();
                this.options.antispam = true;
                return;
            }

            e.preventDefault();
            var view = this;

            if(this.options.antispam){
                return;
            }

            var errorElement = view.$('#card-errors');
            view.$('#card-errors p').addClass('hide');

            if(this.$('#card-name').val().length < 2){
                view.$('#card-errors p[data-error="name"]').removeClass('hide');
                return;
            }


            this.options.antispam = true;

            this.options.stripe.createToken(this.options.cardCvc, {name: this.$('#card-name').val(), address_zip: customerZip}).then(function(result) {

                console.log(result.error);
                if (result.error) {
                    view.options.antispam = false;
                    // Inform the user if there was an error
                    view.$('#card-errors p[data-error="' + result.error.code + '"]').removeClass('hide');
                } else {
                    // Send the token to your server 
                    this.$('#payment-form input[name=stripeToken]').val(result.token.id);
                    this.$('#payment-form').submit();
                }
            });
        },
        payWithPaypal: function(e){
            gtag('event', 'set_checkout_option', {
                "checkout_step": 2,
                "checkout_option": "payment",
                "value": "paypal"
            });
        }
    });
}(jQuery, window, document));
